import { Box, Button, Grid } from '@mui/material'
import { backgroundColors } from '../../Components/Common/Color/Color'
import EventTable from '../../Components/Report/EventReport/EventTable'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/store'
import { fetchEvents } from '../../redux/event/manageEvents/actions'
import RefreshIcon from '@mui/icons-material/Refresh'
import EventFilter from '../../Components/Events/EventFilter'
import SearchInput from '../../Components/Common/SearchInput'
import { selectSearchQuery } from '../../redux/event/manageEvents/selector'
import { setSearchQuery } from '../../redux/event/manageEvents/slice'
import EventReportCard from '../../Components/Report/EventReport/Chart/EventReportCard'
import { fetchEventDetailsReport } from '../../redux/reports/event/action'
import EventReportChart from '../../Components/Report/EventReport/Chart/EventReportChart'

const EventReportPage = () => {
  const dispatch = useAppDispatch()
  const searchQuery = useAppSelector(selectSearchQuery)

  const fetchData = async () => {
    await dispatch(fetchEvents()).unwrap()
    await dispatch(fetchEventDetailsReport())
  }

  useEffect(() => {
    fetchData()
  }, [dispatch])

  const handleRefreshData = async () => {
    await fetchData()
  }

  const handleSearchChange = (query: string) => {
    dispatch(setSearchQuery(query))
  }

  const handleClearSearch = () => {
    dispatch(setSearchQuery(''))
  }

  return (
    <Box
      component='div'
      sx={{ p: 0, backgroundColor: backgroundColors.white, width: 'auto' }}
      borderRadius={2}
      boxShadow={1}
    >
      <Box sx={{ p: 2 }}>
        <EventReportCard />
        <EventReportChart />
      </Box>
      <Grid container sx={{ p: 2 }} flexDirection='row' alignItems={'center'} justifyContent='end'>
        <Grid>
          <Grid container spacing={2} alignItems='center' display='flex'>
            <Grid>
              <Button
                id='refresh-button'
                color='success'
                startIcon={<RefreshIcon />}
                onClick={handleRefreshData}
              >
                Refresh
              </Button>
            </Grid>

            <Grid>
              <EventFilter />
            </Grid>
            <Grid>
              <SearchInput
                searchQuery={searchQuery}
                onSearchChange={handleSearchChange}
                onClearSearch={handleClearSearch}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box>
        <EventTable />
      </Box>
    </Box>
  )
}

export default EventReportPage
